import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=9b5361e0"
import script from "./CustomButton.vue?vue&type=script&lang=ts"
export * from "./CustomButton.vue?vue&type=script&lang=ts"
import style0 from "./CustomButton.vue?vue&type=style&index=0&id=9b5361e0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b5361e0')) {
      api.createRecord('9b5361e0', component.options)
    } else {
      api.reload('9b5361e0', component.options)
    }
    module.hot.accept("./CustomButton.vue?vue&type=template&id=9b5361e0", function () {
      api.rerender('9b5361e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/new/buttons/CustomButton.vue"
export default component.exports